import { AiInsights_AiInsightListItem_Type as AiInsightListItem_Type } from '@zendesk/zqa-services/autoqa'
import { AutoQaSpotlightType } from '@/types/spotlight'
import { AutoQaCategoryType } from '@/types/category'

import { AutoValidationError } from '@/modules/settings/components/ai/types'

export const systemSpotlightMap = {
  [AiInsightListItem_Type.DEAD_AIR]: AutoQaSpotlightType.DeadAir,
  [AiInsightListItem_Type.RECORDING_DISCLOSURE]: AutoQaSpotlightType.RecordingDisclosure,
}

export const systemCategoryMap = {
  [AiInsightListItem_Type.COMPREHENSION]: AutoQaCategoryType.Comprehension,
}

export const includesHandledValidationError = (error: string) => {
  const errorsArray = error.split(';').map((error) => error.trim())
  const enumValues: string[] = Object.values(AutoValidationError)
  return errorsArray.some((error) => enumValues.includes(error.toLowerCase()))
}
